import { render, staticRenderFns } from "./IconCamOff.vue?vue&type=template&id=b241f7fa&"
import script from "./IconCamOff.vue?vue&type=script&lang=js&"
export * from "./IconCamOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports